import { useMutation, useQuery } from '@tanstack/react-query';
import { generateQuizReq, getQuestionsListReq, checkAnswerReq, uploadDocReq, generateDocumentQuizReq } from '../api';
import { toast } from 'react-toastify';
import Notification from '../../components/Notification';
import { useDispatch } from "react-redux";
import { closeModal, openModals } from "../../redux/modal.slice";
import { setQuestions } from "../../redux/questions.slice";
import ModalsEnum from "../../enums/modal.enum";

export const useGenerateQuizMutation = (categoryTitle, testYourself) => {
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: ['generate-quiz'],
        mutationFn: async (data) => {
            const response = await generateQuizReq({ ...data });
            return response.data;
        },
        onSuccess: async (data, variables) => {
            dispatch(closeModal());
            dispatch(
                openModals({
                    modalIds: [ModalsEnum.QUIZ_QUESTIONS_MODAL],
                    modalData: [
                        { 
                            className: `big-modal ${testYourself ? 'full-size' : ''}`,
                            quiz_option: variables?.question_type,
                            num_questions: variables?.num_questions,
                            categoryTitle: categoryTitle,
                            testYourself: testYourself
                        }
                    ]
                })
            );
            dispatch(setQuestions(data?.questions));
        },
        onError: (error) => {
            dispatch(closeModal());
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

export const useQuestionsListQuery = (category, filterDate) => {
    const { isLoading, data } = useQuery ({
        queryKey: ['questions-list', category, filterDate ],
        queryFn: async () => {
            try {
                const response = await getQuestionsListReq(category, filterDate);
                return response?.data;
            } catch (error) {
                return false;
            }
        },
        retry: false,
        refetchOnWindowFocus : false,
    });
    return { isLoading, data }
}

export const useCheckAnswerMutation = (id) => {
    return useMutation({
        mutationKey: ['check-answer', id],
        mutationFn: async (data) => {
            const response = await checkAnswerReq({ ...data }, id);
            return response.data;
        },
        onError: (error) => {
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

export const useUploadDocumentMutation = () => {
    const dispatch = useDispatch();
    return useMutation({
        mutationKey: ['upload-document'],
        mutationFn: async (data) => {
            const response = await uploadDocReq(data);
            return response.data;
        },
        onError: (error) => {
            dispatch(closeModal());
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};

export const useDocumentGenerateQuizMutation = (categoryTitle, id) => {
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: ['generate-quiz-document'],
        mutationFn: async (data) => {
            const response = await generateDocumentQuizReq({ ...data }, id);
            return response.data;
        },
        onSuccess: async (data, variables) => {
            dispatch(closeModal());
            dispatch(
                openModals({
                    modalIds: [ModalsEnum.QUIZ_QUESTIONS_MODAL],
                    modalData: [
                        { 
                            className: 'big-modal',
                            quiz_option: variables?.question_type,
                            num_questions: variables?.num_questions,
                            categoryTitle: categoryTitle
                        }
                    ]
                })
            );
            dispatch(setQuestions(data?.questions));
        },
        onError: (error) => {
            dispatch(closeModal());
            toast.error(<Notification text={error.response.data.detail || 'Something went wrong.'} icon={'warning'} />);
        },
    });
};